import { createUseStyles } from 'react-jss'
import { typography } from '@dentalux/ui-library-core'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  nextAvailableSlotsContainer: {
    background: 'white',
    padding: 18,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    [forPhoneOnly]: {
      gap: 12,
    },
  },
  nextAvailableSlotsText: {
    ...typography['Lato Body 1'],
    marginRight: 8,
    [forPhoneOnly]: {
      ...typography['Lato Body 2'],
    },
  },
  boldedText: {
    ...typography['Lato Emphasized 1'],
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 2'],
    },
  },
  divider: {
    width: '100%',
    height: 1,
    background: theme.palette.grey[300],
  },
  slotsContainer: {
    display: 'flex',
    gap: 8,
    [forPhoneOnly]: {
      flexWrap: 'wrap',
    },
  },
  slot: {
    padding: '14px 24px',
    border: `1px solid ${theme.palette.primary[800]}`,
    borderRadius: 8,
    color: theme.palette.primary[800],
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    ...typography['Lato Emphasized 2'],
    [forPhoneOnly]: {
      padding: '12px 15px',
    },
  },
  lastSlot: {
    [forPhoneOnly]: {
      display: 'none',
    },
  },
  selected: {
    background: theme.palette.highlight2[800],
    border: `1px solid ${theme.palette.highlight2[800]}`,
    color: 'white',
  },
  moreSlot: {
    display: 'flex',
    justifyContent: 'center',
    background: theme.palette.primary[75],
    '&:hover': {
      background: theme.palette.primary[100],
    },
  },
}))
